export default "__VITE_ASSET__77bb86f0__"